import React from "react";
import {Link} from "@inertiajs/react";

/**
 * Zeigt die Anzahl der Änderungen eines Lagerabgleich-Laufs als Link auf die
 * zugehörige Detailseite (vollständige Liste der geänderten Artikel). Bei 0
 * Änderungen gibt es nichts zu verlinken, dann wird nur die Zahl angezeigt.
 *
 * `basePath` bestimmt das Ziel je Log (B2B/B2C) und wird über
 * `makeChangesCountLinkTableCell()` fest verdrahtet, damit die
 * customCellRendererMap ohne Zusatz-Props auskommt.
 */
function ChangesCountLinkTableCell({id, className, children, childSwitch, rowData, basePath}) {
    const raw = React.Children.toArray(children)
        .filter((c) => typeof c === "string" || typeof c === "number")
        .map(String)
        .join("")
        .trim();

    const count = parseInt(raw, 10) || 0;

    return (
        <td key={id} className={`border px-4 py-2 text-nowrap${className ? " " + className : ""}`}>
            {childSwitch}
            {count > 0 && rowData?.id ? (
                <Link href={`${basePath}/${rowData.id}`} className="text-decoration-underline">
                    {count}
                </Link>
            ) : (
                count
            )}
        </td>
    );
}

/**
 * Erzeugt eine an einen festen Basis-Pfad gebundene Renderer-Komponente, die
 * direkt in customCellRendererMap eingetragen werden kann.
 */
export function makeChangesCountLinkTableCell(basePath) {
    return function BoundChangesCountLinkTableCell(props) {
        return <ChangesCountLinkTableCell {...props} basePath={basePath} />;
    };
}

export default ChangesCountLinkTableCell;
